import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Card, Header, Icon } from 'semantic-ui-react'
import moment from 'moment'

import ReservationUpdatedBy from 'Components/ReservationUpdatedBy'

import { DEFAULT_MOMENT_FORMAT } from 'Global/constants'
import { getUserName } from 'Global/Helpers/userHelpers'

class ReservationEvent extends Component {
  static propTypes = {
    current: PropTypes.bool,
    editable: PropTypes.bool,
    reservation: PropTypes.object.isRequired,
    showEditReservationModal: PropTypes.func,
  }

  static defaultProps = {
    editable: true,
  }

  editReservation = () => {
    const { reservation, showEditReservationModal } = this.props

    showEditReservationModal(reservation)
  }

  render() {
    const { current, editable, reservation } = this.props

    const description = (
      <div>
        {editable && (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a onClick={this.editReservation} style={{ float: 'right' }}>
            <Icon name="write" size="large" />
          </a>
        )}

        {moment(reservation.dateFrom).format(DEFAULT_MOMENT_FORMAT)}
        {'–'}
        {moment(reservation.dateTo).format(DEFAULT_MOMENT_FORMAT)}
      </div>
    )

    return (
      <div>
        <br />
        <Card.Description>{current ? <Header as="h5">{description}</Header> : <div>{description}</div>}</Card.Description>

        <Card.Meta>
          {getUserName(reservation.createdBy)}
          <ReservationUpdatedBy reservation={reservation} />
        </Card.Meta>

        {reservation.event && <Card.Description>#{reservation.event.name}</Card.Description>}

        {reservation.reason && <Card.Description>{reservation.reason}</Card.Description>}
      </div>
    )
  }
}

export default ReservationEvent
